import { useEffect } from "react";

// استدعاء دوري يتوقف عندما تكون الصفحة في الخلفية، ويُنفَّذ مرة عند العودة إليها،
// فلا تبقى الشاشة تُحدِّث نفسها بلا توقف وتستهلك الشبكة والبطارية.
export const usePoll = (callback, intervalMs, deps = []) => {
  useEffect(() => {
    let timer = null;
    const run = () => callback();

    const start = () => {
      if (timer || document.hidden) return;
      timer = setInterval(run, intervalMs);
    };
    const stop = () => {
      clearInterval(timer);
      timer = null;
    };
    const onVisibility = () => {
      if (document.hidden) {
        stop();
      } else {
        run();
        start();
      }
    };

    run();
    start();
    document.addEventListener("visibilitychange", onVisibility);
    return () => {
      stop();
      document.removeEventListener("visibilitychange", onVisibility);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intervalMs, ...deps]);
};
